// 경과 시간 로거 유틸 함수
import toast from 'react-hot-toast';

/**
 * 경과 시간을 측정하고 로그 및 토스트로 출력하는 로거 생성 함수
 *
 * @param options - ElapsedTimeLoggerOptions 타입의 옵션 객체
 * @returns 종료 시점에 호출 가능한 함수. 호출 시 경과 시간을 계산하여 출력
 *
 * @example
 * const startedAt = Date.now();
 * const logTime = createElapsedTimeLogger({ startTime: startedAt, eventName: '데이터 처리' });
 * // ... 작업 ...
 * logTime(); // "데이터 처리: 2.34초" 출력
 */
// 옵션 타입 정의
type ElapsedTimeLoggerOptions = {
  startTime?: number;
  eventName?: string;
  enableToast?: boolean;
  enableLog?: boolean;
  duration?: number;
};
export const createElapsedTimeLogger = ({
  startTime,
  eventName = '',
  enableToast = true,
  enableLog = true,
  duration = 5000
}: ElapsedTimeLoggerOptions = {}) => {
  const _startTime = startTime ?? Date.now();
  return () => {
    const endTime = Date.now();
    const elapsedTime = ((endTime - _startTime) / 1000).toFixed(2); // 경과 시간 계산 (초 단위)

    if (enableToast) {
      toast(`${eventName}: ${elapsedTime}초`, {
        duration
      }); // 토스트 출력
    }
    if (enableLog) {
      console.warn(`[Elapsed Time] ${eventName}: ${elapsedTime}초`); // 콘솔 로그 출력
    }
    return elapsedTime;
  };
};